/* danario Startseite: Vorher-Nachher-Schieber, Montagevideo, Kuechenvorschau nur am Handy. */
(function () {
  function initBeforeAfter(root) {
    root.querySelectorAll('.dnh-ba__stage').forEach(function (stage) {
      if (stage.dataset.dnhReady) return;
      stage.dataset.dnhReady = '1';
      var range = stage.querySelector('.dnh-ba__range');
      if (!range) return;
      var set = function () { stage.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  function initVideos(root) {
    root.querySelectorAll('.dnh-video').forEach(function (box) {
      var btn = box.querySelector('.dnh-video__btn');
      if (!btn || btn.dataset.dnhReady) return;
      btn.dataset.dnhReady = '1';
      btn.addEventListener('click', function () {
        var src = box.getAttribute('data-src');
        if (!src) return;
        var v = document.createElement('video');
        v.src = src;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        box.appendChild(v);
        btn.remove();
        var dur = box.querySelector('.dnh-video__dur');
        if (dur) dur.remove();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
  }

  /* Der Vorschau-Abschnitt steht als <template> im HTML und wird nur auf schmalen
     Bildschirmen eingesetzt. Am Desktop erscheint er nirgends auf der Seite. */
  function initMobileOnly(root) {
    var mq = window.matchMedia('(max-width: 749px)');
    root.querySelectorAll('template[data-dnh-mobile-only]').forEach(function (tpl) {
      if (tpl.dataset.dnhDone) return;
      var insert = function () {
        if (!mq.matches || tpl.dataset.dnhDone) return;
        tpl.dataset.dnhDone = '1';
        tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
      };
      insert();
      if (!tpl.dataset.dnhDone) {
        var onChange = function () { insert(); };
        if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
      }
    });
  }

  function init(root) {
    initBeforeAfter(root);
    initVideos(root);
    initMobileOnly(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
